export enum QuestionTypeEnum {
  Single_Choice = 1,
  Multiple_Choice = 2,
  Star_Rating = 3,
  Text_Area = 4
}

export enum QuestionTypeCodeEnum {
  Single_Choice = "Single_Choice",
  Multiple_Choice = "Multiple_Choice",
  Star_Rating = "Star_Rating",
  Text_Area = "Text_Area",
  Numeric = "Numeric"
}
